
import UpadateTeamForm from "./UpdateTeamForm";
import GoBackToSingleTeamBtnPresenter from "./GoBackToSingleTeamBtn/GoBackToSingleTeamBtnPresenter";

export const TeamListComponents = {
    Form: UpadateTeamForm,
    goBackBtn: GoBackToSingleTeamBtnPresenter
}

export default TeamListComponents